import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { ILocation } from '../types/location';
import { Selection } from '../components/dashboard/selection';
import { PositionService } from '../http/position-service';

export default class PositionStore {
    private _loading = false;
    private _items: ILocation[] = [];
    private _requestId = 0;

    constructor() {
        makeObservable<PositionStore, '_loading' | '_items'>(this, {
            _loading: observable,
            _items: observable,
            loading: computed,
            items: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get items(): ILocation[] {
        return this._items;
    }

    async load(selected: Selection) {
        const id = ++this._requestId;
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await PositionService.getPositions(selected);
            if (id !== this._requestId) return;
            const data = Array.isArray(answer.data) ? answer.data : [answer.data];
            runInAction(() => {
                this._items = data;
            });
        } catch (e) {
            if (id !== this._requestId) return;
            console.log(e);
        } finally {
            if (id === this._requestId) {
                runInAction(() => {
                    this._loading = false;
                });
            }
        }
    }
}
